import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { QueryResults, WeatherConstraintFromQueryString } from '../types';

export const useParseQueryString = (traceHistory?: boolean) => {
  const dispatch = useAppDispatch();
  const { selectedSnapshotId } = useAppSelector((state) => state.snapshots);
  const { selectedAnalyzerId } = useAppSelector((state) => state.analyzers);
  const queryRef = useRef<string>('');

  const queryString = useLocation().search;

  const [results, setResults] = useState<QueryResults>({
    hasQueryString: false,
    startTime: null,
    endTime: null,
    snapshotIdToLoad: -1,
    analyzerIdToLoad: -1,
    traceIndex: 0,
    weather: false,
    forecast: false,
    weatherConstraints: [],
    dishIdToLoad: -1,
    redirectPath: null,
  });

  useEffect(() => {
    if (!queryString || queryString === queryRef.current || traceHistory)
      return;
    const query = new URLSearchParams(queryString);

    const snapshotIdFromQuery = query.get('snapshot');
    const analyzerIdFromQuery = query.get('analyzer');
    const dishIdFromQuery = query.get('dish');
    const startTime = query.get('start');
    const endTime = query.get('end');
    const trace = query.get('trace');
    const traceIndex = trace ? Number(trace) - 1 : 0;
    const weatherConstraintsToAdd: WeatherConstraintFromQueryString[] = [];
    const isWeather = Number(query.get('weather'));
    const isForecast = Number(query.get('forecast'));
    const redirectPath = query.get('redirect');
    let constraintIdx = 0;
    while (isWeather || isForecast) {
      const measurement = query.get('m' + constraintIdx);
      if (!measurement) break;
      const level = query.get('l' + constraintIdx);
      const greaterThan = query.get('g' + constraintIdx);
      if (level && greaterThan) {
        weatherConstraintsToAdd.push({
          // @ts-ignore
          measurement,
          level: Number(level),
          greaterThan: !!Number(greaterThan),
        });
      }
      constraintIdx += 1;
    }

    queryRef.current = queryString;
    setResults({
      hasQueryString: !!queryString,
      startTime,
      endTime,
      snapshotIdToLoad: snapshotIdFromQuery ? Number(snapshotIdFromQuery) : -1,
      analyzerIdToLoad: analyzerIdFromQuery ? Number(analyzerIdFromQuery) : -1,
      traceIndex,
      weatherConstraints: weatherConstraintsToAdd,
      weather: isWeather ? true : false,
      forecast: isForecast ? true : false,
      dishIdToLoad: dishIdFromQuery ? Number(dishIdFromQuery) : -1,
      redirectPath,
    });
  }, [
    dispatch,
    queryString,
    selectedAnalyzerId,
    selectedSnapshotId,
    traceHistory,
  ]);

  return results;
};
